// extracted by mini-css-extract-plugin
export default {"header":"_9DTDFcDyFAvx-mQXxk2yGw=="};